<template>
    <section class="container">
        <div class="d-flex justify-content-center">
            <img :src="$mq.phone ? '/static/img/survey/q_chang_phone.jpg':'/static/img/survey/q_chang_web.jpg'" class="img-fluid" alt="...">
        </div>
        <form data-vv-scope="survey-q-chang" @submit.prevent="formSubmit()">
            <div class="text-center mt-3">
                <h4>
                    เปิดรับสมัคร คุณแม่บ้านบริการทำความสะอาดในเครือ Q-Chang (คิวช่าง)
                </h4>
                <h4>กรุณากรอกแบบสอบถามให้ครบทุกข้อ</h4>
            </div>
            <div >
                <label for="interested">คุณแม่บ้านสนใจลงทะเบียน หรือไม่</label>
                <div class="row no-gutters pl-2">
                    <div class="exp" :class="$mq.phone ? 'col-6' : 'col-2'" >
                        <div class="checkbox">
                          <input type="radio"
                                 name="interested"
                                 id="interest"
                                 value="สนใจ"
                                 v-validate="'required'"
                                 v-model="form.interested"/>
                          <label class="mb-3" for="interest">
                            <span> </span>
                            สนใจ
                          </label>
                        </div>
                    </div>
                    <div class="exp" :class="$mq.phone ? 'col-6' : 'col-2'" >
                        <div class="checkbox">
                          <input type="radio"
                                 name="interested"
                                 id="no_interest"
                                 value="ไม่สนใจ"
                                 v-validate="'required'"
                                 v-model="form.interested"/>
                          <label class="mb-0" for="no_interest">
                            <span> </span>
                            ไม่สนใจ
                          </label>
                        </div>
                    </div>
                </div>
                <div class="mt-1 text-remark -status-alert" v-if="errors.has('survey-q-chang.interested')">
                    {{ $t('message.required_field') }}
                </div>
                <div class="form-group" v-if="form.interested == 'ไม่สนใจ'">
                    <label>เหตุผล</label>
                    <div class="select-jumbo" :style="$mq.phone ? '' : 'width:40%'">
                        <select v-model="form.causes">
                            <option value="ไม่สะดวก หากไม่ได้เข้าให้บริการในนามของ BeNeat">
                                ไม่สะดวก หากไม่ได้เข้าให้บริการในนามของ BeNeat
                            </option>
                            <option value="ไม่สะดวกในส่วนของขั้นตอนปฏิบัติที่หลายขั้นตอน">
                                ไม่สะดวกในส่วนของขั้นตอนปฏิบัติที่หลายขั้นตอน
                            </option>
                            <option value="ไม่สะดวกถ่ายรุป ก่อน-หลัง การเข้าให้บริการ">
                                ไม่สะดวกถ่ายรุป ก่อน-หลัง การเข้าให้บริการ
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="text-center pb-5">
                <button type="submit" class="btn btn__submit btn-lg px-5 mt-3" :disabled="disableState">
                    Submit
                </button>
            </div>
        </form>
    </section>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({
    form: {
      interested: '',
      causes: ''
    },
    disableState: true
  }),
  watch: {
    'form.interested' (newVal, oldVal) {
      if (newVal === 'สนใจ') {
        this.form.causes = ''
      }
      if (newVal) {
        this.disableState = false
      }
    }
  },
  methods: {
    formSubmit () {
      this.$validator.validate().then(valid => {
        if (valid) {
          this.save()
        }
      })
    },
    async save () {
      this.form.professional_id = this.professionalId
      const params = {
        professional_id: this.professionalId,
        data: this.form,
        type: 'survey_3'
      }
      const config = {
        headers: { Authorization: this.accessToken }
      }
      let swalOption = {
        type: 'error',
        title: 'ไม่สำเร็จ',
        text: 'กรุณาตรวจสอบลิงก์แบบฟอร์มหรือติดต่อเจ้าหน้าที่',
        showConfirmButton: false,
        showCloseButton: true
      }
      try {
        const { data } = await axios.post('/surveys', params, config)
        if (!data.error) {
          swalOption = {
            type: 'success',
            title: 'บันทึกสำเร็จ',
            text: 'ขอขอบคุณท่านที่ให้ความสนใจ',
            showConfirmButton: false,
            showCloseButton: true
          }
        }
      } catch (error) {
        swalOption = {
          type: 'error',
          title: error.message,
          text: 'กรุณาตรวจสอบลิงก์แบบฟอร์มหรือติดต่อเจ้าหน้าที่',
          showConfirmButton: false,
          showCloseButton: true
        }
      }
      this.$swal(swalOption)
    }
  },
  created () {
    this.professionalId = this.$route.query.professional_id
    if (this.$route.query.access_token) {
      this.accessToken = `Bearer ${this.$route.query.access_token}`
    }
  }
}
</script>
<style scoped>
.btn__submit {
    background-color: #3cc1d8;
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/QChangSurvey.vue